import React from "react";

/**
 * Reusable Eyebrow component for section and card labeling.
 * Standardizes the monospaced, uppercase, widely spaced clinical look.
 *
 * @param {Object} props - Component props.
 * @param {React.ReactNode} props.children - The eyebrow text.
 * @param {string} [props.className] - Additional CSS classes.
 * @returns {JSX.Element} Eyebrow component.
 */
const Eyebrow = ({ children, className = "" }) => (
    <span className={`eyebrow text-eyebrow ${className}`}>
        {children}
    </span>
);

export default Eyebrow;
